@if (show()) {
  <section
    class="w-[calc(100%-2.5rem)] h-full absolute top-0 left-xl z-1 bg-white rounded-md">
    <div class="flex flex-col justify-center items-center h-full gap-5xl">
      <lib-medical-case-icon [iconClass]="'w-[10.5rem] h-[9.375rem]'" />

      <div class="text-center">
        <h1 class="text-xl font-bold text-neutral-900 mb-sm">
          {{ 'maintenance_title' | transloco }}
        </h1>

        <p class="text-sm font-medium text-neutral-500 w-[25.5rem]">
          {{ 'maintenance_description' | transloco }}
        </p>
      </div>
    </div>
  </section>
}
